import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {catchError, map, of} from 'rxjs';
import {SupervisorService} from '../../core/service/supervisor.service';

export const supervisorLandingGuardFn: CanActivateFn = () => {
  const supervisorService = inject(SupervisorService);
  const router = inject(Router);

  return supervisorService.getLandingRoute().pipe(
    map(route => router.createUrlTree(route)),
    catchError(() => of(router.createUrlTree(['/error'])))
  );
};
